export async function downloadBase64File(base64: string, filename: string, mimeType: string): Promise<void> {
    const byteCharacters: string = atob(base64)
    const byteNumbers: number[] = new Array(byteCharacters.length)
    for (let i: number = 0; i < byteCharacters.length; i++) {
        const byteChar: number | undefined = byteCharacters.codePointAt(i)
        if (byteChar) byteNumbers[i] = byteChar
    }
    const byteArray: Uint8Array<ArrayBuffer> = new Uint8Array(byteNumbers)

    const blob: Blob = new Blob([byteArray], { type: mimeType })

    downloadBlob(blob, filename)
}

export function downloadBlob(blob: Blob, filename: string): void {
    const url: string = URL.createObjectURL(blob)
    const link: HTMLAnchorElement = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
}
